import { Pipe, PipeTransform } from "@angular/core";
import { DANISH_LOCALE } from "src/environments/constants";

@Pipe({
    name: "parseCardDate",
    standalone: false,
})
export class ParseCardDatePipe implements PipeTransform {
    transform(value: Date, type: string) {
        if (type === "date") {
            return value.toLocaleDateString(DANISH_LOCALE);
        } else {
            return value.toLocaleTimeString(DANISH_LOCALE, { hour: "2-digit", minute: "2-digit" });
        }
    }
}
